import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyPageIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 62,
	height: 61,
	viewBox: "0 0 62 61",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 31.0013,
			cy: 43.2083,
			rx: 2.54167,
			ry: 2.54167,
			transform: "rotate(-180 31.0013 43.2083)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 35.582L31 17.7903M8.125 23.209V37.7884C8.125 41.6602 10.1388 45.2379 13.4078 47.1738L25.7172 54.4634C28.9862 56.3993 33.0138 56.3993 36.2828 54.4634L48.5922 47.1738C51.8612 45.2379 53.875 41.6602 53.875 37.7884V23.209C53.875 19.3372 51.8612 15.7595 48.5922 13.8236L36.2828 6.53395C33.0138 4.59806 28.9862 4.59806 25.7172 6.53395L13.4078 13.8236C10.1388 15.7595 8.125 19.3372 8.125 23.209Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgEmptyPageIcon);
export default ForwardRef;
